export const WEEKDAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const

export const TIME_ZONE_OPTIONS = [
  'America/Sao_Paulo',
  'America/New_York',
  'America/Los_Angeles',
  'Europe/London',
] as const

export type EditableAvailabilityWindow = {
  id?: string
  weekday: number
  startMinutes: number
  endMinutes: number
  label?: string | null
  active?: boolean
}

export function minutesToTimeValue(minutes: number) {
  const hours = Math.floor(minutes / 60).toString().padStart(2, '0')
  const mins = (minutes % 60).toString().padStart(2, '0')
  return `${hours}:${mins}`
}

export function timeValueToMinutes(value: string) {
  const [hours, mins] = value.split(':').map((part) => Number(part))
  return ((hours || 0) * 60) + (mins || 0)
}

export function createDefaultAvailabilityWindows(): EditableAvailabilityWindow[] {
  return [1, 2, 3, 4, 5].map((weekday) => ({
    weekday,
    startMinutes: 9 * 60,
    endMinutes: 18 * 60,
    label: '',
    active: true,
  }))
}

export function addDaysToDateKey(dateKey: string, days: number) {
  const [year, month, day] = dateKey.split('-').map(Number)
  const next = new Date(Date.UTC(year, month - 1, day + days))
  return `${next.getUTCFullYear()}-${String(next.getUTCMonth() + 1).padStart(2, '0')}-${String(next.getUTCDate()).padStart(2, '0')}`
}

export function getDateKeyInTimeZone(date: Date, timeZone: string) {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })

  return formatter.format(date)
}
